import { gql } from "@apollo/client";

export const MOVE_USER_TO_SEAT = gql`
  mutation MoveUserToSeat($userId: ID!, $seatType: String!) {
    moveUserToSeat(userId: $userId, seatType: $seatType) {
      success
      errors
      user {
        id
        size
        pageQuota
        usedPages
      }
    }
  }
`; 